import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { SectionTopTitle } from 'components/base/CommonComponent';
import CustomDateTimeSelect from 'components/base/CustomDateTimeSelect';
import {
  ReactHookFormErrorMessage,
  hasError,
} from 'components/base/ErrorFieldMessage';
import InputFieldControl from 'components/base/InputFieldControl';
import PeriodAndWeekdaySection from 'components/base/period/PeriodAndWeekdaySection';
import ReactHookFormTitleWithRadio from 'components/reactHookFormComponents/ReactHookFormTitleWithRadio';
import { VALID_PERIOD_TYPE } from 'models/CreateCouponModel';

import './CouponDateTimeSelector.scss';
import { COUPON_TYPES } from 'config/CustomEnums';

const couponDatetimeOptions = {
  [COUPON_TYPES.NORMAL]: [
    { label: 'All the time', value: VALID_PERIOD_TYPE.ALL_TIME },
    { label: 'In a period', value: VALID_PERIOD_TYPE.ABSOLUTE },
    {
      label: 'Numbers of day since acquiring',
      value: VALID_PERIOD_TYPE.RELATIVE,
    },
  ],
  [COUPON_TYPES.TICKET]: [
    { label: 'All the time', value: VALID_PERIOD_TYPE.ALL_TIME },
    { label: 'In a period', value: VALID_PERIOD_TYPE.ABSOLUTE },
  ]
};
const CouponDateTimeSelector = ({
  title ="Valid period",
  fieldNameFrefix = "",
  defaultValidPeriodType = VALID_PERIOD_TYPE.ALL_TIME,
}) => {
  const {
    watch,
    formState: { errors },
    setValue,
  } = useFormContext();
  const typeField = `${fieldNameFrefix}type`;
  const validPeriodTypeFieldName = `${fieldNameFrefix}validPeriodType`;
  const numberOfDaysFieldName = `${fieldNameFrefix}numberOfDaysToExpireAfterAcquisition`;
  const absoluteEffectiveDateFieldName = `${fieldNameFrefix}absoluteEffectiveDate`;
  const absoluteExpiryDateFieldName = `${fieldNameFrefix}absoluteExpiryDate`;
  const validPeriodValuesFieldName = `${fieldNameFrefix}validPeriodValues`;
  const validWeekdayFieldName = `${fieldNameFrefix}validWeekday`;

  const watchType = watch(typeField) || COUPON_TYPES.NORMAL;
  const watchValidPeriodType = watch(validPeriodTypeFieldName);

  const watchNumberOfDays = watch(numberOfDaysFieldName);
  const watchAbsoluteEffectiveDate = watch(absoluteEffectiveDateFieldName);
  const watchAbsoluteExpiryDate = watch(absoluteExpiryDateFieldName);
  const periodValues = watch(validPeriodValuesFieldName);
  const weekday = watch(validWeekdayFieldName);
   useEffect(()=>{
     if (!watchValidPeriodType && defaultValidPeriodType) {
       setValue(validPeriodTypeFieldName, defaultValidPeriodType, {
         shouldDirty: true,
       });
     }
   }, [watchValidPeriodType, defaultValidPeriodType])

  const daySinceNowView = (
    <div>
      <InputFieldControl
        name={numberOfDaysFieldName}
        title={'Required days'}
        value={watchNumberOfDays}
        setValue={(value) => {
          setValue(numberOfDaysFieldName, value, {
            shouldDirty: true,
          });
        }}
        type="number"
        unit="days"
        className="coupon-campaign-section-input"
      />
    </div>
  );

  const periodView = (
    <div>
      <div className="second-section">
        <label className="create-section-label">Start date</label>
        <CustomDateTimeSelect
          defaultTime={watchAbsoluteEffectiveDate}
          onTimeChange={(datetime) => {
            setValue(absoluteEffectiveDateFieldName, datetime, {
              shouldDirty: true,
            });
          }}
        />
      </div>
      <div className="second-section">
        <label className="create-section-label">End date</label>
        <CustomDateTimeSelect
          defaultTime={watchAbsoluteExpiryDate}
          error={hasError(errors, absoluteExpiryDateFieldName)}
          onTimeChange={(datetime) => {
            setValue(absoluteExpiryDateFieldName, datetime, { shouldDirty: true });
          }}
          seconds={59}
          // hideTime={true}
        />
        <ReactHookFormErrorMessage errors={errors} id={absoluteExpiryDateFieldName} />
      </div>
    </div>
  );

  return (
    <div>
      {title && <SectionTopTitle title={title} />}
      <ReactHookFormTitleWithRadio
        title={"Valid period"}
        options={couponDatetimeOptions?.[watchType]}
        valueFieldName={validPeriodTypeFieldName}
      />
      <div
        className="second-section no-margin"
        hidden={
          watchValidPeriodType === VALID_PERIOD_TYPE.RELATIVE ? false : true
        }
      >
        {daySinceNowView}
      </div>
      <div
        hidden={
          watchValidPeriodType === VALID_PERIOD_TYPE.ABSOLUTE ? false : true
        }
      >
        {periodView}
      </div>

      <PeriodAndWeekdaySection
        switchButtonTitle="Blackout period"
        periodValuesField={validPeriodValuesFieldName}
        periodValues={periodValues}
        periodValuesChange={(data) => {
          setValue(validPeriodValuesFieldName, data, { shouldDirty: true });
        }}
        weekday={weekday}
        weekdayChange={(data) => {
          setValue(validWeekdayFieldName, data, { shouldDirty: true });
        }}
        maxDate={watchAbsoluteExpiryDate}
        minDate={watchAbsoluteEffectiveDate}
        disabledDate={watchValidPeriodType === VALID_PERIOD_TYPE.ABSOLUTE}
      />
    </div>
  );
};

export default CouponDateTimeSelector;
